module.exports = __webpack_public_path__ + "static/media/HistCaro-11.f82f4bad.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/figures/history/HistCaro-11.png
// module id = 772
// module chunks = 0